import { useSelector } from 'react-redux'

import Logger from 'core/utils/Logger'

import { selectIsInitialized } from '../selectors'

export const useCheckI18NextInitialization = (): boolean => {
  const isInitialized = useSelector(selectIsInitialized)

  if (!isInitialized) {
    Logger.log('[Translation]: i18next is not initialized yet')
  }

  return isInitialized
}
